var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 58 58",
    style: {
      enableBackground: "new 0 0 58 58"
    },
    xmlSpace: "preserve",
    width: "64px",
    height: "64px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F05565"
    },
    points: "47,4 47,8 40,8 40,4 16,4 16,8 9,8 9,4 1,4 1,15 55,15 55,4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EFEBDE"
    },
    points: "9,15 1,15 1,58 55,58 55,15 47,15 40,15 16,15  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D5D0BB"
    },
    d: "M38,22h-2h-7h-2h-7h-2H9v9v2v7v2v9h9h2h7h2h7h2h9v-9v-2v-7v-2v-9H38z M29,24h7v7h-7V24z M36,40h-7 v-7h7V40z M20,33h7v7h-7V33z M20,24h7v7h-7V24z M11,24h7v7h-7V24z M11,33h7v7h-7V33z M18,49h-7v-7h7V49z M27,49h-7v-7h7V49z  M36,49h-7v-7h7V49z M45,49h-7v-7h7V49z M45,40h-7v-7h7V40z M38,31v-7h7v7H38z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    style: {
      fill: "#36495E"
    },
    width: 7,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    style: {
      fill: "#36495E"
    },
    width: 7,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 33,
    style: {
      fill: "#7F6E5D"
    },
    width: 7,
    height: 7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3D324C"
    },
    d: "M56.707,55.293l-6.797-6.797l6.483-3.241l-17.637-6.498l6.499,17.637l3.241-6.484l6.797,6.797 C55.488,56.902,55.744,57,56,57s0.512-0.098,0.707-0.293C57.098,56.316,57.098,55.684,56.707,55.293z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.36b9b7ddcf8b9446785041ea0dccc1d5.svg";
export { ForwardRef as ReactComponent };